module.exports = __webpack_public_path__ + "img/symbol_15.7d5f7040.png";